import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserModel } from "../shared/models/user-model";
import { BaseService } from "./base.service";

@Injectable()
export class AuthenticationService extends BaseService {
  constructor(
    public http: HttpClient //  public local: Location
  ) {
    super(http);
  }
  public Login(data: UserModel) {
    let value = {
      clientUser: data.username.toLocaleLowerCase(),
      passwordUser: data.password
    };
    return this.Post("getLoginCuentaCoome", value, false);
  }


  public sendToken(data: any) {    
    return this.Post("enviarToken", data, false);
  }

  public sendLogin(data: any) {    
    return this.Post("login", data, false);
  }

  public validToken(data: any) {    
    return this.Post("validarToken", data, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts